import { useEffect, useState } from "react";

interface DelayedSpinnerProps {
  /** Nothing is drawn before this — a wait shorter than it never flashes. */
  delayMs?: number;
  /** Fill the viewport (app boot) instead of the content area (page load). */
  fullHeight?: boolean;
}

/** Loading indicator that only appears for waits long enough to notice. */
function DelayedSpinner({ delayMs = 250, fullHeight = false }: DelayedSpinnerProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs]);
  if (!visible) return null;
  return (
    <div
      className={`d-flex justify-content-center align-items-center w-100 ${
        fullHeight ? "full-vh-height" : "py-5"
      }`}
    >
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default DelayedSpinner;
